export const ALOOMA_PATH = 'https://api-d.imageeyedownload.com';
export const ALOOMA_TOKEN = 'sBGUbZm3hp';

export const ALOOMA_ELEMENT_NAMES = {
  SUBMIT: 'submit',
};

export const ALOOMA_PAGE_NAMES = {
  extension_uninstall: 'extension_uninstall',
};

export const ALOOMA_NOT_STANDARD_DATA = {
  user_id: 16,
  component: 'imageye',
};
